import { BaseModel } from './base-model';

export class AutoITRDetails extends BaseModel {
    uuid: String = null;
    partyType: Number = null;

    isResidentialStatusInIndia: Boolean = null;
    isDirectorInompany: Boolean = null;
    hasHeldAnyUnlistedEquitySharesDuringPreviousYear: Boolean = null;
    hasAnyAssetOrSigningAuthorityOrIncomeFromOutsideIndia: Boolean = null;

    incomeFromSalaryOrPension: Boolean = null;
    incomeOnlyfromOneHouseproperty: Boolean = null;
    incomeTaxableOsOnlyFromInterestOrFamilyPension: Boolean = null;
    incomeFromBusinessOrProfessionComputedOn44AD_44ADA_44AE: Boolean = null;
    capitalGains: Boolean = null;
    profitsAndGainsFromBpSbAbCommissionBrokerage: Boolean = null;
    isIncomeWithProvisionsOfSection5A: Boolean = null;
    isAgriculturalIncomeInExcess: Boolean = null;
    hasAnyClaimsOfLossDeductionsReliefTaxCredit: Boolean = null;
}